module.exports = {
	inviteCode: "邀请码",
	changeAvatar: "点击更换",
	edit: "修改",
	company: "公司名称",
	address: "所在区域",
	description: "个人描述",
	website: "个人网站",
	lengthLong: "{{name}} 的长度不能超过 {{max}}",
	newPassword: "新密码",
	inviteCodeDes: "您可以发送邀请码给好友，注册时填写该邀请码将获得代金券："
}


// WEBPACK FOOTER //
// ./src/pages/detail/i18n/locale.zh-cn.js